import { render, staticRenderFns } from "./contact-component.vue?vue&type=template&id=14571255"
import script from "./contact-component.vue?vue&type=script&lang=ts"
export * from "./contact-component.vue?vue&type=script&lang=ts"
import style0 from "./contact-component.vue?vue&type=style&index=0&id=14571255&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports